import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnRequestDateEmailRenderer } from "./email";
import type { ReturnRequestDateBlockProps } from "./types";

export function ReturnRequestDateEditorRenderer(
  props: ReturnRequestDateBlockProps,
) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ReturnRequestDateEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
